// ⚠️ MOCK — dados ilustrativos para validação com o cliente.
// Remover este arquivo quando as queries reais forem implementadas (ver PRD §14).
//
// Políticas e Procedimentos (Policy). Módulo pobre em dado: Policy só tem
// title, description, link, isPortuguese, isSpanish, country, createdAt, updatedAt.
// Foco em COBERTURA e ATUALIZAÇÃO. As INTERFACES são o CONTRATO das futuras queries.

export interface PoliciesKpis {
    totalDocuments: number;         // total de Policy
    countriesCovered: number;       // COUNT(DISTINCT country)
    availablePt: number;            // isPortuguese=true
    availableEs: number;            // isSpanish=true
    missingEsTranslation: number;   // isPortuguese=true AND isSpanish=false (gap)
    staleOver12Months: number;      // updatedAt < hoje-12m
}

// Gráfico 1 — Documentos por país (ColumnChart)
export interface DocumentsByCountryRow {
    country: string;
    count: number;
}

// Gráfico 2 — Cobertura de idioma por país (ColumnChart percent)
// base real: flags isPortuguese / isSpanish.
export interface LanguageCoverageRow {
    country: string;
    onlyPt: number;
    onlyEs: number;
    both: number;
}

// Gráfico 3 — Publicações por trimestre (ColumnChart, createdAt)
export interface PublicationsByQuarterRow {
    quarter: string;   // 'T3/24' …
    count: number;
}

// Gráfico 4 — Antiguidade dos documentos (PieChart, faixas por updatedAt)
export interface DocumentAgeRow {
    range: 'lt6' | 'm6to12' | 'm12to24' | 'gt24';
    count: number;
}

// ===========================================================================

export const MOCK_KPIS: PoliciesKpis = {
    totalDocuments: 64,
    countriesCovered: 5,
    availablePt: 58,
    availableEs: 41,
    missingEsTranslation: 23,
    staleOver12Months: 17,
};

// soma = 64 (= totalDocuments)
export const MOCK_DOCUMENTS_BY_COUNTRY: DocumentsByCountryRow[] = [
    {country: 'Brasil', count: 31},
    {country: 'Argentina', count: 11},
    {country: 'Chile', count: 9},
    {country: 'Colômbia', count: 8},
    {country: 'Peru', count: 5},
];

// onlyPt=23 (= missingEsTranslation) · onlyEs=6 · both=35
// (both+onlyPt = 58 = availablePt · both+onlyEs = 41 = availableEs)
export const MOCK_LANGUAGE_COVERAGE: LanguageCoverageRow[] = [
    {country: 'Brasil', onlyPt: 10, onlyEs: 1, both: 20},
    {country: 'Argentina', onlyPt: 3, onlyEs: 2, both: 6},
    {country: 'Chile', onlyPt: 4, onlyEs: 1, both: 4},
    {country: 'Colômbia', onlyPt: 3, onlyEs: 1, both: 4},
    {country: 'Peru', onlyPt: 3, onlyEs: 1, both: 1},
];

export const MOCK_PUBLICATIONS_BY_QUARTER: PublicationsByQuarterRow[] = [
    {quarter: 'T3/24', count: 5},
    {quarter: 'T4/24', count: 7},
    {quarter: 'T1/25', count: 6},
    {quarter: 'T2/25', count: 9},
    {quarter: 'T3/25', count: 8},
    {quarter: 'T4/25', count: 11},
    {quarter: 'T1/26', count: 10},
    {quarter: 'T2/26', count: 8},
];

// stale (>12m) = m12to24 + gt24 = 10 + 7 = 17 (= staleOver12Months)
export const MOCK_DOCUMENT_AGE: DocumentAgeRow[] = [
    {range: 'lt6', count: 28},
    {range: 'm6to12', count: 19},
    {range: 'm12to24', count: 10},
    {range: 'gt24', count: 7},
];
